export const ORGANIZATION_ANALYTICS_CACHE_TTL_MS = 30 * 60 * 1000;

const normalizeIds = ids => {
  if (!Array.isArray(ids)) {
    return [];
  }

  return [...ids].sort();
};

export const createOrganizationAnalyticsRequestKey = requestData => {
  return JSON.stringify({
    from: requestData?.from ?? null,
    to: requestData?.to ?? null,
    influencerId: requestData?.influencerId ?? null,
    influencerIds: normalizeIds(requestData?.influencerIds),
    chatterIds: normalizeIds(requestData?.chatterIds),
  });
};
